<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="logo" style="text-align: center; margin: 25px auto">
          <img
            style="max-width: 300px"
            src="https://www.sarexpress.com/assets/img/navbar-logo.svg"
          />
        </div>
        <h2 style="text-align: center; color: #000">Cambiar contraseña</h2>
      </div>
    </div>
    <div v-if="!exito" class="row">
      <div style="max-width: 330px; margin: auto">
        <p class="text-center" style="color: #000; line-height: 1.35">
          Utilice el siguiente formulario para cambiar su contraseña.
        </p>
        <form method="post" id="passwordForm" @submit="submit">
          <input
            v-model="password1"
            type="password"
            class="input-lg form-control"
            name="password1"
            id="password1"
            placeholder="Nueva contraseña"
            autocomplete="off"
          />

          <input
            v-model="password2"
            type="password"
            class="input-lg form-control"
            name="password2"
            id="password2"
            placeholder="Repite la contraseña"
            autocomplete="off"
          />
          <p v-if="error" class="text-center" style="color: #000; line-height: 1.35">
            {{error}}
          </p>
          <button
            type="submit"
            class="col-12 btn btn-primary btn-lg"
            style="margin-top: 10px"
            data-loading-text="Cambio de contraseña ..."
          >
            Cambia la contraseña
          </button>
        </form>
      </div>
      <!--/col-sm-6-->
    </div>
    <div v-else id="page-top" class="formulario py-5">
      <div class="container">
        <div class="col text-center py-5">
          <img :src="logo" height="40px" alt />
        </div>
      </div>
      <div class="my-5">
        <div class="message-card container p-3" role="form">
          <h3>Tu contraseña ha sido cambiada con exito</h3>
          <span>Ya puedes iniciar sesión</span>
          <div class="volver-inicio">
            <button class="btn btn-primary" @click="goToLogin">
              Volver al portal
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--/row-->
  </div>
</template>
<script>
import { changePassword } from "@/service/api";
export default {
  data() {
    return {
      password1: "",
      password2: "",
      error: null,
      exito: false,
    };
  },
  methods: {
    submit(evt) {
      evt.preventDefault();
      this.error = null;
      if (this.password1 !== this.password2) {
        this.error = "Las contraseñas no coinciden";
      } else if (this.password1.length < 8) {
        this.error = "La contraseña debe tener por lo menos 8 caracteres";
      } else {
        changePassword(this.$route.query.token, this.password1)
          .then((res) => res.json())
          .then((response) => {
            console.log(response);
            this.exito = true;
          })
          .catch(() => {
            this.error =
              "Ocurrio un error. Por favor vuelva a intentar más tarde";
          });
      }
    },
    goToLogin() {
      this.$router.push("/login");
    },
  },
};
</script>
<style>
</style>
